import request from '@/utils/request'

export function privilegeActiviteTotal(query) {
    return request({
        url: '/user/privilege-statistics/privilege-total',
        method: 'get',
        params: query
    })
}

export function privilegeActiviteDetail (query) {
    return request({
        url: '/user/privilege-statistics/privilege-detail',
        method: 'get',
        params: query
    })
}
